module.exports = __webpack_public_path__ + "static/img/spring_banner.ec4ccaa7.jpg";